<!--
 * @Author: cryi.liu
 * @Date: 2020-05-06 09:35:40
 * @LastEditTime: 2020-05-06 17:42:04
 * @Description: 原 PSS 风格主区域
 -->
<template>
  <div class="pss__main">
    <pss-sider />
    <pss-page>
      <slot />
    </pss-page>
  </div>
</template>

<script>
import PssSider from '../sider/Index.vue';
import PssPage from './Page.vue';

export default {
  name: 'PssMain',
  components: {
    PssSider,
    PssPage,
  },
};
</script>

<style lang="less" scoped>
.pss__main {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: calc(100% - 70px - 90px);
  padding: 15px;
  box-sizing: border-box;
  overflow: hidden;
}
</style>
